module.exports = __webpack_public_path__ + "static/product-2-1c4d86da83917e466089b08493c217fc.png";